import { styled } from 'styled-components';
import { hexToRGB } from '@/styles/helpers';
import theme from '@/theme';

export const ScTooltip = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .tooltip-icon {
    color: ${({ theme }) => theme.color2};
    font-weight: 400;
  }

  &:hover .tooltip-icon {
    color: ${({ theme }) => theme.whiteColor};
  }
`;

export const overlayStyle = {
  opacity: '1',
  borderRadius: '12px',
  zIndex: 10,
  boxShadow: `0px 4px 10px ${hexToRGB(theme.color41, 0.3)}`,
};
